import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=2afa3f73&scoped=true"
import script from "./Application.vue?vue&type=script&lang=js"
export * from "./Application.vue?vue&type=script&lang=js"
import style0 from "./Application.vue?vue&type=style&index=0&id=2afa3f73&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa3f73",
  null
  
)

export default component.exports